<template>
  <div class="noticia">
      <v-container>
            <v-layout row>
                <v-flex md9 xs12>
                    <Noticia />
                </v-flex>
                <v-flex md3 xs12>
                    <Servicios />
                </v-flex>
            </v-layout>
        </v-container>
  </div>
</template>

<script>
const Noticia = () => import('@/components/Noticia.vue')
const Servicios = () => import('@/components/Servicios.vue')

export default {
    name: 'NoticiasDetalle',
    components: {
        Noticia,
        Servicios
    },
}
</script>